//////////////////////////////////////////////////////////
//                                                      //   
//  PARA CLIENTES E USUÁRIOS DESLOGADOS:                //   
//                                                      //   
//  ABA LATERAL DIREITA QUE APARECE APÓS O CLICK DA     //
//  SACOLA NAS PÁGINAS DE CHECKOUT DETALHES E HOME      //
//                                                      //   
//  FUNCIONALIDADE: ABA DO CARRINHO                     //
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/pages/chekout.js                                   //
//      frontend/src/pages/detalhe.js                                   //
//      frontend/src/pages/home.js                                      //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import ProdutoCarrinho from './produto_carrinho'

function ItensComprados(produtos) {   
    
    // CALCULA O PREÇO FINAL DO CARRINHO
    var preco_total = 0

    for (var i = 0; i < produtos.props.length; i++){
        var chave = produtos.props[i].id

        var preco = produtos.props[i][chave]['preco']
        var quantidade = produtos.props[i][chave]['carrinho']

        preco_total = preco_total + preco*quantidade
    }

    // FORMATA O PREÇO (FORMATO XX.Y PARA XX,YY)
    var preco_lista = preco_total.toString().split('.')

    if(preco_lista.length === 2){
        var cents = preco_lista[1]
        
        if(cents.length === 1){
            cents = cents + '0'
        }
        if(cents.length > 2){
            cents = cents.slice(0, 2)
        }

        preco_lista[1] = cents
    }
    else if (preco_lista.length === 1){
        cents = '00'
        preco_lista.push(cents)
    }

    // DEFINE SE O BOTÃO DE CHECKOUT VAI APARECER (COM BASE SE A LOJA TEM CADASTRO NA PAGSEGURO)
    // if (produtos.botao){
        var botao = <button className='btn-verde mt-4 pull-right mr-5' onClick={() => go_to_checkout()}>
                        <i className="fa fa-credit-card-alt mr-4"></i>
                        Checkout
                    </button>
    // }
    // else{
    //     var botao = <div></div>
    // }


    function go_to_checkout(){  // FUNÇÃO QUE REDIRECIONA PARA A PÁGINA DE CHECKOUT
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO 'Checkout' DESTE COMPONENTE

        if(sessionStorage['login']){  // CASO O USUÁRIO ESTIVER LOGADO
            window.location.href = '/checkout/?id=' + window.location.search.split('=')[1]  // REDIRECIONA PARA A PÁGINA CHECKOUT
        }
        else{  // CASO O USUÁRIO NÃO ESTIVER LOGADO
            window.location.href = '/login'  // REDIRECIONA PARA A PÁGINA DE LOGIN
        }
    }

    var preco_final = preco_lista.join(',')        

    // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
      // 'ProdutoCarrinho' -> CADA PRODUTO NO CARRINHO

    return (
        <div className='itens-comprados d-none' id="itens">
            <div className="row col col-12 mx-0 height-header-carrinho">
                <div className="row col-9 col px-0 mx-0">
                    <h3 className="mt-3 mb-2 verde px-2 montserrat fonte-x-large">Carrinho</h3>
                </div>

                <div className="col-3 pl-0 mt-2 mb-2">
                    <button className="cancel-pqn my-1 mx-1 pull-right" onClick={close_carrinho}>
                        <i className="fa fa-close"></i>
                    </button>    
                </div>
            </div>

            <div className="body-carrinho">

                {produtos.props.map((block, index) => (
                    <ProdutoCarrinho key={index} produto={block} callback={produtos.callback}/>
                ))}
            </div>

            <div className='w-100 border-top-gray'>
                <div className="row col col-12 px-0 mx-0">
                    <div className="col-6">
                        <div className='preco_total my-3'>R$ {preco_final}</div>
                    </div>

                    <div className="col-6">
                        {botao}
                    </div>
                </div>
            </div>

        </div>                    
    );
  }


  function close_carrinho(){
    document.getElementById("itens").classList.add('d-none')
    document.getElementById("body_proj").classList.remove('hide-scroll')
  }
  export default ItensComprados;
  